import React from 'react';

const Scroller = ({ currentIdx, goTo }) => {
  const sections = [
    { id: 0, label: 'Accueil', ariaLabel: 'Aller à la page d\'accueil' },
    { id: 1, label: 'Savoir-Faire', ariaLabel: 'Aller à la section savoir-faire' },
    { id: 2, label: 'Boutique', ariaLabel: 'Aller à la boutique' },
    { id: 3, label: 'Contact', ariaLabel: 'Aller à la section contact' }
  ];

  return (
    <div className="scroller" role="navigation" aria-label="Navigation entre sections">
      {sections.map((section) => (
        <button
          key={section.id}
          className={`dot ${currentIdx === section.id ? 'active' : ''}`}
          onClick={() => goTo(section.id)}
          aria-label={section.ariaLabel}
          aria-current={currentIdx === section.id ? 'page' : undefined}
          title={section.label}
        />
      ))}
    </div>
  );
};

export default Scroller;
